import axios from 'axios';

export const publishForm = async (
    formId: string,
    organizationId: string,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) =>
    axios
        .post(
            organizationId.trim() === ''
                ? `/rep/form/publish/${formId}`
                : `/rep/form/publish/${formId}/${organizationId}`,
            {},
            {
                headers: {
                    'Toast-Pending-Text': toastText?.onPendingText,
                    'Toast-Success-Text': toastText?.onSuccessText,
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
